import React from 'react';
import ScrollFocusComponent from '@synergycms_core/components/HoC/scrollFocusComponent';

import { compose, pipe, filter, reduce, find, sortBy, sort, pluck, flatten, slice, curry, values, forEach, concat, map,prop } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './engineDropDownList.js';
import { RichText, Link, Image } from '@synergycms_core/components/generic';
import { replaceSearchValue, simplifyValueArray, simplifyValueWithSpace, replaceInputSearchValue } from './engineUtils';
import { CSSTransition } from 'react-transition-group';

import storage from '../../../utils/storage';
import Button from '../../generic/Button';


const Plugger = compose(
  withThemeJSS({ displayName: 'EngineDropDownList', styleFile, link: true })
)(class plugger extends React.Component {
  static displayName = 'Plugger';
  constructor(props) {
    super(props);
    this.state = {
    byUser: false,
    userPlugged: props.plugged
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (state.byUser && nextProps.plugged !== state.plugged) {
      return {
        plugged: nextProps.plugged,
        userPlugged: nextProps.plugged
      };
    }
    return null;
  }



  plugElement = () => {
    this.setState((state) => {
      const plugged = state.byUser ? !state.userPlugged : !this.props.plugged;
      return { byUser:true, userPlugged: plugged };
    });
  }

  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;
    const plugged = this.state.byUser ? this.state.userPlugged : this.props.plugged
    const euroStartTheme = theme.theme === 'eurostarshotels' || theme.theme === 'eurostarshotelcompany' || theme.theme === 'portalDesign';

    return (<>
      <Button
        onClick={this.plugElement}
        config={{
          rightIcon: {
              unicodeContent:plugged ? 'e0f8' : 'e02e',
              innerStyle: ['gold', 'size12']
          }
        }}
        innerStyle={classes.toggleButton}
      />
      <CSSTransition
          in={!plugged}
          timeout={euroStartTheme ? 0 : 500}
          mountOnEnter
          unmountOnExit
          classNames={{
            enter: classes.hotelListEnter,
            enterActive: classes.hotelListEnterActive,
            exit: classes.hotelListLeave,
            exitActive: classes.hotelListLeaveActive
          }}>
          <div className={classes.pluggedContainer}>{this.props.children}</div>
        </CSSTransition>
    </>);
  };
});


const EngineDestinations = compose(
  withThemeJSS({ displayName: 'EngineDropDownList', styleFile, link: true })
)(class engineDestinations extends React.Component {
  static displayName = 'EngineDestinations';

  render() {
    const { destinationsList, hotelsList, theme, value, selectSearch, modalBreak } = this.props;
    const { classes } = theme.styles;

    return (<div className={!!destinationsList.length && !!hotelsList.length ? classes.list : classes.listAlone}>
      {!(theme.theme === 'portalDesign' && theme.deviceType !== 'DESK') && (
        <RichText
          plural={true}
          translate={true}
          ucFirst={true}
          text={'destino'}
          innerStyle={['roboto16BoldBlack', classes.dispoTitle]}
          icon={
            modalBreak && { unicodeContent: 'e166', innerStyle: classes.lastSearchIcon }
          }
        />
      )}
      {theme.theme === 'portalDesign' && destinationsList.map(destination => (
        <div key={destination.name + destination.id} className={classes.listElementPortalDesign}>
          <div
            onClick={selectSearch(destination)}
            key={destination.name + destination.id}
            className={classes.boxInfoDestination}>
            <div className={classes.boxIconNameDest}>
              <Image svg={'destinationMark'} />
              <div
                dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, destination) }}
                className={classes.listNamePortalDesign}
              />
            </div>
            <div>
              {destination.hotels && <RichText text={destination.hotels.length} innerStyle={classes.numberElementsPortalDesign} />}
              {destination.hotels && <RichText translate={true} text={'_%hotel%_'} plural={destination.hotels.length > 1} innerStyle={classes.textElementsPortalDesign} />}
            </div>
          </div>
        </div>
      ))}

      {theme.theme != 'portalDesign' && destinationsList.map(destination => (
        <div key={destination.name + destination.id} className={classes.listElement}>
          <div
            onClick={selectSearch(destination)}
            key={destination.name + destination.id}>
            <div
              dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, destination) }}
              className={classes.listName}
            />
              {destination.hotels && <RichText text={' (' + destination.hotels.length + ')'} innerStyle={classes.numberElements} />}
          </div>
        </div>
      ))}
    </div>);
  };
});

const EngineNestedDestinations = compose(
  withThemeJSS({ displayName: 'EngineDropDownList', styleFile, link: true })
)(class engineNestedDestinations extends React.Component {
  static displayName = 'EngineNestedDestinations';

  render() {

    const { destinationsList, hotelsList, theme, value, selectSearch, modalBreak } = this.props;
    const { classes } = theme.styles;
    return (<div className={!!destinationsList.length && !!hotelsList.length ? classes.flexedList : classes.listAlone}>
      <RichText
        plural={true}
        translate={true}
        ucFirst={true}
        text={'destino'}
        innerStyle={['roboto16BoldBlack', classes.dispoTitle]}
        icon={
          modalBreak && { unicodeContent: 'e166', innerStyle: classes.lastSearchIcon }
        }
      />
      {destinationsList.map(destination => (
        <div key={destination.name + destination.id} className={classes.listContainer}>
          <div
            className={classes.titleTextContainer}
            onClick={selectSearch(destination, "destination")}
            key={destination.name + destination.id}>
            <div
              dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, destination) }}
              className={[classes.listName, classes.listOrigin].join(' ')}
            />
            <RichText
              text={' (' + destination.hotels.length + ')'}
              innerStyle={classes.numberElements}
            />
          </div>
          <Plugger plugged={!destination.filteredCities} >
            {(destination.filteredCities || destination.citiesList).map(city =>
                <div key={city.name + city.id} className={[classes.listElement,classes.noBordered].join(' ')} onClick={selectSearch(city, "destination")}>
                  <div >
                    <div
                      dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, city) }}
                      className={classes.listName}
                    />
                    <RichText text={' (' + city.hotels.length + ')'} innerStyle={classes.numberElements} />
                  </div>
                </div>)}
            </Plugger>
        </div>
      ))}
    </div>);
  };
});

const BRAND_SVGS = {
  5: 'brandEurostarshotelsMinimal',
  7: 'brandExeMinimal',
  12: 'brandTandemMinimal',
  14: 'brandIkonikMinimal',
  41: 'brandAureaMinimal',
  42: 'brandCrisolMinimal',
};

const getHotelBrandImage = (brand_id) => {
  return BRAND_SVGS.hasOwnProperty(brand_id) ? BRAND_SVGS[brand_id] : 'brandDefaultMinimal';
};

class EngineDropDownList extends React.Component {
  static displayName = 'EngineDropDownList';

  constructor(props) {
    super(props);
    this.state = {
      destinationMatch: null
    };
    const {searchList, type} = props.config;
    this.cx = props.theme.bind();
    if(type === "nested_destinations"){
      this.fullDestinations = pipe(values, map((country)=>{
        country.citiesList = pipe(values, sortBy(prop("simpleText")))(country.cities);
        return country;
      }), sortBy(prop("simpleText")))(searchList.mapCountries);
    }

  }

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  setCurrentSearchList = () => {
    const { value, setCurrentSearchList } = this.props.config;

    if (this.currentSearchList && value) {
      const simpleValue = simplifyValueWithSpace(value);
      const findValue = find(object => {
        return object.simpleText.indexOf(simpleValue) === 0;
      }, this.currentSearchList);

      setCurrentSearchList({ matchedText: replaceInputSearchValue(value, findValue), match: findValue });
    } else {
      setCurrentSearchList({ match: null, matchedText: null });
    }
  }

  sortSearchElements = sort((a, b) => {
    if (a.priority < b.priority) {
      return 1;
    } else if (a.priority > b.priority) {
      return -1;
    } else if (a.simple.length > b.simple.length) {
      return 1;
    } else if (a.simple.length < b.simple.length) {
      return -1;
    } else if (a.simpleText > b.simpleText) {
      return 1;
    } else {
      return -1;
    }
  });

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { value, searchList, selectSearch, clearStorage, hotelsCatalog, matchType, type = null, match, emptyMatch = false, modalBreak } = config;
    let { firstLoad } = config;
    let mapDestinations = {};
    let destinationsList = [];
    let hotelsList = [];
    const lastSearchs = storage.getLocal('avail_last_search') || [];
    let destinationComponent;
    const userSearchList = pipe(simplifyValueArray, filter((elem) => (elem.length >= 1)))(value);


    const { mapCountries, mapCities } = searchList;


    const isMatch = curry((userSearchWord, entity) => {
      return find((fullWord) => {
        return fullWord && fullWord.includes(userSearchWord);
      }, entity.simple)
    });

    const extendDestination = (entity) => {
      const countryId = entity.type === "country" ? entity.id : entity.country_id;
      const cityId = entity.type === "city" ? entity.id : entity.city_id;

      let country = mapCountries[countryId];

      if (country) {

        if (!mapDestinations[countryId]) {
          country.filteredCities = {};
        }

        if (cityId) {
          country.filteredCities[cityId] = mapCities[cityId];
        }

        mapDestinations[countryId] = country;

      }
    };


    const parse = (searchList, preMachedEntities = {}) => {
      preMachedEntities = { ...preMachedEntities };
      const unsortedList = reduce((matchedList, userSearchWord) => {

        forEach((entity) => {
          const match = isMatch(userSearchWord, entity);

          match && extendDestination(entity);

          if (match && matchedList[entity.id]) {
            matchedList[entity.id].priority++;
          } else if (match && !matchedList[entity.id]) {
            entity.priority = 1;
            matchedList[entity.id] = entity;
          } else if (!match && !matchedList[entity.id]) {
            entity.priority = 0;
          }

          if (preMachedEntities[entity.id]) {
            matchedList[entity.id] = entity;
            preMachedEntities[entity.id] = null;
          }



        }, searchList);

        return matchedList;
      }, {}, userSearchList);

      return this.sortSearchElements(values(unsortedList));
    };

    let visibleHotelList;
    let visibleDestinationList;
    let visibleLastSearch;
    let visibleNotFound;
    //let visibleLoyalty;
    this.currentSearchList = null;
    switch (type) {
      case "nested_destinations":
        firstLoad = false;
          if (userSearchList.length && !matchType) {
            hotelsList = parse(searchList.hotels);
            parse(searchList.destinations, mapDestinations);
            this.lastDestinationList = destinationsList = pipe(values, map((country)=>{
              country.filteredCities = pipe(values, this.sortSearchElements)(country.filteredCities);
              return country;
            }),this.sortSearchElements)(mapDestinations);

          } else if (matchType && match) {
            hotelsList = match.hotels;
            destinationsList = this.lastDestinationList || [];
          } else if (!value && this.fullDestinations) {
            hotelsList = searchList.hotels;

            destinationsList = pipe(map((country) => {
              country.filteredCities = null;
              return country;
            }),values)(this.fullDestinations);

            this.lastDestinationList = destinationsList = this.fullDestinations;
          }

          visibleHotelList = !!hotelsList.length;
          visibleDestinationList =  !!destinationsList.length;
          visibleLastSearch = false;
          visibleNotFound = !destinationsList.length && !hotelsList.length && value;
          //visibleLoyalty = false;


          destinationComponent = !!destinationsList.length && <EngineNestedDestinations selectSearch={selectSearch} value={value} destinationsList={destinationsList} hotelsList={hotelsList} modalBreak={modalBreak} />
        break;
      default:
        if (userSearchList.length) {
          destinationsList = slice(0, 5, parse(searchList.destinations));

          const hotelsById = pipe(pluck("hotels"), flatten(), reduce((acc, entity) => {
            acc[entity.id] = entity;
            return acc;
          }, {}))(destinationsList);

          hotelsList = slice(0, 5, parse(searchList.hotels, hotelsById));
        }
        visibleHotelList = !firstLoad && !!hotelsList.length;
        visibleDestinationList = !firstLoad && !!destinationsList.length;
        visibleLastSearch =(firstLoad && !!lastSearchs.length) || (!value && !!lastSearchs.length);
        visibleNotFound = (!firstLoad && !destinationsList.length && !hotelsList.length && value) || emptyMatch ;
        //visibleLoyalty = !this.isMobile() && !firstLoad && (!!destinationsList.length || !!hotelsList.length) && group === 'eurostarshotels' && !userLogIn;

        destinationComponent = !!destinationsList.length && <EngineDestinations selectSearch={selectSearch} value={value} destinationsList={destinationsList} hotelsList={hotelsList} modalBreak={modalBreak} />
        this.currentSearchList = concat(hotelsList, destinationsList);
        this.setCurrentSearchList();

    }


    return (
      <div
        onClick={e => e.stopPropagation()}
        className={[
          theme.computedInnerStyle,
          this.cx({
            smallTable: (!firstLoad && !destinationsList.length && !hotelsList.length && value) || (emptyMatch && !visibleLastSearch && (!visibleHotelList || !visibleDestinationList)),
            maxList: type === 'nested_destinations'
          })
        ].join(' ')} >


        {visibleDestinationList && destinationComponent}

        {visibleHotelList && (
          <div className={[!!destinationsList.length && !!hotelsList.length ? classes.list : classes.listAlone, theme.theme === 'portalDesign' && theme.deviceType !== 'DESK' ? classes.mobileBorderTop : '', this.cx({ flexedList: type === 'nested_destinations'})].join(' ')}>
            {!(theme.theme === 'portalDesign' && theme.deviceType !== 'DESK') && (
              <RichText
                plural={true}
                translate={true}
                ucFirst={true}
                text={'hotel'}
                innerStyle={['roboto16BoldBlack', classes.dispoTitle]}
                icon={
                  theme.deviceType !== 'DESK' && { unicodeContent: 'e165', innerStyle: classes.lastSearchIcon }
                }
              />
            )}

            {theme.theme === 'portalDesign' && hotelsList.map(hotel => {
              const city = mapCities[hotel.city_id];
              const country = mapCountries[hotel.country_id];

              return (
                <React.Fragment key={hotel.name + hotel.id}>
                  <div onClick={selectSearch(hotel)} className={classes.listElementPortalDesign} >
                      <div className={classes.boxBrandHotel}>
                        <Image svg={getHotelBrandImage(hotel.brand)} />
                        <div className={classes.boxHotelName} dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, hotel) }} />
                      </div>
                      {(city && country) && (
                        <span className={classes.cityCountryText}>
                          <span dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, city) }} />
                            {replaceSearchValue(value, city) && replaceSearchValue(value, country) ? ', ' : ''}
                          <span dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, country) }} />
                        </span>
                      )}
                  </div>

                  {hotel.hotels && (
                    <RichText text={' (' + hotel.hotels.length + ')'} innerStyle={classes.numberElements} />
                  )}
                </React.Fragment>
              );
            })}

            {theme.theme !== 'portalDesign' && hotelsList.map(hotel => (
              <React.Fragment key={hotel.name + hotel.id}>
                <div
                  onClick={selectSearch(hotel)}
                  key={hotel.name + hotel.id}
                  dangerouslySetInnerHTML={{ __html: replaceSearchValue(value, hotel) }}
                  className={classes.listElement}
                />
                {hotel.hotels && <RichText text={' (' + hotel.hotels.length + ')'} innerStyle={classes.numberElements} />}
              </React.Fragment>
            ))}
          </div>
        )}



        {visibleNotFound && (
            <div className={classes.notFoundSearch}>
              <RichText plural={true} translate={true} ucFirst={true}
                text={'_%no se han encontrado destinos con este nombre%_'} />
              {!this.isMobile() && (
                <Link
                  richText={{
                    text: '_%ir al listado de hoteles%_',
                    rightIcon: { unicodeContent: 'e000', innerStyle: classes.seeHotelListIcon },
                    ucFirst: true,
                    translate: true
                  }}
                  innerStyle={classes.seeHotelList}
                  href={hotelsCatalog ? (hotelsCatalog.url ? hotelsCatalog.url : hotelsCatalog) : '#'}
                  target={'_blank'}
                />
              )}
            </div>)
        }
        {
          visibleLastSearch && (
            <div className={classes.listAlone}>
              <div className={theme.theme === 'portalDesign' ? classes.dispoTitlePortalDesign : classes.dispoTitle}>
                <RichText
                  plural={true}
                  translate={true}
                  ucFirst={true}
                  text={'_%tus últimas búsquedas%_'}
                  innerStyle={'roboto16BoldBlack'}
                  icon={
                    modalBreak && {
                      unicodeContent: 'e155',
                      innerStyle: [classes.lastSearchIcon, theme.theme === 'portalDesign' ? classes.lastSearchIconPortalDesign : '']
                    }
                  }
                />
                <Button
                  innerStyle={classes.clearSearch}
                  onClick={() => {
                    clearStorage();
                    this.forceUpdate();
                  }}
                  icon={{ unicodeContent: 'e08a' }}
                />
              </div>

              {lastSearchs.map(searchs => (
                <div className={theme.theme === 'portalDesign' ? classes.boxLastSearchs : ''} onClick={selectSearch(searchs)} key={searchs.name + searchs.id}>
                  {theme.theme === 'portalDesign' && (
                    <Image svg={searchs.type ? 'destinationMark' : getHotelBrandImage(searchs.brand)} />
                  )}
                  <RichText
                    plural={true}
                    translate={true}
                    text={searchs.name}
                    innerStyle={[theme.theme === 'portalDesign' ? classes.listElementPortalDesign : classes.listElement]}
                  />
                </div>
              ))}
            </div>)
        }

      </div>
    );
  }
}

export default compose(
  PropertyManager([
    'value',
    'searchList',
    'selectSearch',
    'firstLoad',
    'mode',
    'type',
    'clearStorage',
    'group',
    'hotelsCatalog',
    'mapCountries',
    'mapCities',
    'matchType',
    'match',
    "setCurrentSearchList",
    "emptyMatch",
    'modalBreak'
  ]),
  ScrollFocusComponent({}),
  withThemeJSS({ styleFile, link: true })
)(EngineDropDownList);
